module.exports = __webpack_public_path__ + "img/第8章_4-1_賴和館1樓.jpg";